export default class Accordeon {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    this.items = this.el.querySelectorAll('.accordeon--item')

    this.items.forEach((item) => {
      item.querySelector('.accordeon--trigger').addEventListener('click', () => {
        const isActive = item.classList.contains('is-active')

        this.items.forEach(other => other.classList.remove('is-active'))

        if (!isActive) item.classList.add('is-active')
      })
    })
  }
}
